export const pnrMarkers: Array<L.LatLngTuple> = [
  [327.00, 782.50],
  [360.50, 723.50],
  [440.50, 748.50],
  [468.50, 698.00],
  [551.50, 695.50],
  [681.00, 591.00],
  [581.00, 573.00],
  [556.00, 578.50],
  [443.50, 520.50],
  [657.00, 441.00],
  [793.00, 358.50],
  [939.00, 338.50],
  [1064.50, 325.50],
  [1063.50, 446.00],
  [976.00, 465.50],
  [876.00, 500.00],
  [775.00, 614.50],
  [735.00, 612.50],
  [745.00, 714.50],
  [778.50, 776.00],
  [942.00, 633.00],
  [1117.00, 647.00],
  [1219.00, 585.00],
  [1208.50, 520.50],
  [1294.00, 537.50],
  [1364.00, 489.00],
  [1458.00, 588.50],
  [1472.50, 595.50],
  [1485.50, 586.50],
  [1471.00, 671.00],
  [1483.50, 667.00],
  [1537.50, 406.00],
  [1325.50, 283.00],
  [1696.00, 390.50],
  [1687.50, 404.50],
  [1845.00, 609.50],
  [1826.00, 710.00],
  [1846.00, 707.50],
  [1955.00, 558.00],
  [2002.00, 660.00],
  [2073.00, 584.00],
  [2083.50, 594.00],
  [2157.00, 542.00],
  [2199.00, 603.50],
  [2274.50, 578.50],
  [2303.00, 606.50],
  [2389.50, 691.50],
  [2368.00, 734.50],
  [2438.00, 679.00],
  [2491.50, 666.50],
  [2553.50, 619.50],
  [2562.00, 696.50],
  [2611.50, 675.50],
  [2632.50, 724.00],
  [2655.50, 683.50],
  [2683.00, 633.50],
  [2790.50, 641.00],
  [2808.50, 671.50],
  [2842.50, 639.00],
  [2925.50, 710.00],
  [3064.50, 753.50],
  [3087.00, 714.00],
  [3140.50, 728.00],
];
